module.exports = __webpack_public_path__ + "img/layout_free_tree_icon.3947939d.svg";